import { NumberRangeReadModel } from "../GeneratedClients/FreeBillApi"
import { apiService } from "../apiService"
import trimWhiteSpacesFromString from "../helpers/trimWhiteSpacesFromString"

const numberRangeValidator = async(string: string, id?: string) => {
  const {data} = await apiService.NumberRangesApi.getNumberRanges()
  const dataWithoutOldModel = data.filter(numberRange => numberRange.id !== id)
  const valueExists = validateValue(string, dataWithoutOldModel)
  const nameExists = validateName(string, dataWithoutOldModel)
  if(valueExists || nameExists) return 'Der Wert existiert bereits.'
}

const validateValue = (string: string, data: NumberRangeReadModel[]) => {
  return data.some(x => trimWhiteSpacesFromString(x.value?.toLowerCase()) === trimWhiteSpacesFromString(string?.toLowerCase()))
}

const validateName = (string: string, data: NumberRangeReadModel[]) => {
  return data.some(x => trimWhiteSpacesFromString(x.name?.toLowerCase()) === trimWhiteSpacesFromString(string?.toLowerCase()))
}


export default numberRangeValidator